/**
 * lib/views/javascripts/proto/relay-float.js — the floating Relay window a
 * Proto host (lib/proto/serve.js) puts on every page of an agent with a Relay
 * child (lib/views/htmls/proto/relay-float.ejs).
 *
 * The channel header's undock button calls window.__relayUndock.open(), which
 * loads /relay-body into the frame the first time; Dock closes it, and the
 * bar drags the window. Non-modal: the page behind stays usable.
 *
 * Contents: view
 * Ontology: Code object M33C-1034 (immutable ref — assigned once, never edit)
 * Team: J. Brant Arseneau & the Mach33 Agents.
 */

// ── Binding ──────────────────────────────────────────────────────────────
export function bindRelayFloat(doc = document, win = window) {
  const float = doc.getElementById('m33-relay-float');
  if (!float || float.__wired) return;
  float.__wired = 1;
  const frame = float.querySelector('#m33-relay-frame');
  const dock = float.querySelector('#m33-relay-dock');
  const bar = float.querySelector('#m33-relay-bar');
  win.__relayUndock = {
    open() {
      if (!frame.getAttribute('src')) frame.setAttribute('src', '/relay-body');
      float.classList.add('open');
    },
    close() { float.classList.remove('open'); }
  };
  dock.addEventListener('click', win.__relayUndock.close);

  // ── Drag ───────────────────────────────────────────────────────────────
  let drag = false, ox = 0, oy = 0;
  bar.addEventListener('mousedown', (e) => {
    if (e.target.id === 'm33-relay-dock') return;
    drag = true;
    const r = float.getBoundingClientRect();
    ox = e.clientX - r.left;
    oy = e.clientY - r.top;
    e.preventDefault();
  });
  win.addEventListener('mousemove', (e) => {
    if (!drag) return;
    float.style.left = Math.max(0, e.clientX - ox) + 'px';
    float.style.top = Math.max(0, e.clientY - oy) + 'px';
  });
  win.addEventListener('mouseup', () => { drag = false; });
}
